export default 'Terms & Conditions'
